/**
 * The id of the ROLE-category user group that designates an administrator.
 *
 * Admins with no assigned SITE groups are allowed to pick from all sites in the
 * navbar site selector. Defined here as a single constant so it is easy to
 * change (e.g. if the id differs between environments).
 */
const ADMIN_USER_GROUP_ID = 1;

export default ADMIN_USER_GROUP_ID;
